<div>
  <div style="display: flex; align-items: flex-end; gap: 15px; height: 40px">
    <div class="expanded-info-section-title">{{ 'Settings.Users' | translate }}</div>
    <div (click)="show = !show" style="cursor: pointer">
      <mat-icon style="font-size: 24px" *ngIf="show">keyboard_arrow_up</mat-icon>
      <mat-icon style="font-size: 24px" *ngIf="!show">chevron_right</mat-icon>
    </div>
  </div>

  <div *ngIf="show" class="table-container scrollbar">
    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <mat-header-cell class="header-cell" *matHeaderCellDef> {{ 'Settings.Name' | translate }} </mat-header-cell>

        <mat-cell class="cell" *matCellDef="let row"> {{ row.name || '-' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <mat-header-cell *matHeaderCellDef class="header-cell"> {{ 'Settings.Lastname' | translate }} </mat-header-cell>

        <mat-cell *matCellDef="let row" class="cell"> {{ row.lastName || '-' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="email">
        <mat-header-cell class="header-cell" *matHeaderCellDef> {{ 'Settings.Email' | translate }} </mat-header-cell>

        <mat-cell class="cell" *matCellDef="let row"> {{ row.email || '-' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="role">
        <mat-header-cell *matHeaderCellDef class="header-cell">
          {{ 'Settings.Permissions' | translate }}
        </mat-header-cell>

        <mat-cell class="cell" *matCellDef="let row"> {{ 'Settings.UserLevel.' + row.role | translate }} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></mat-row>
    </mat-table>
  </div>
</div>
